module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/original-399480aa174e9b18120ca5bbba2917d8.png";